export const taskStatusEnum = {
  not_start: '未开始',
  closed: '已结束',
  progress: '进行中',
  terminal: '已终止'
}
